import { MessageCircle } from 'lucide-react';
import { cn } from '../lib/utils';
import { sdkBridge } from '../sdk-bridge';

type ButtonLauncherProps = {
  organizationId: string;
  assistantId: string;
};

export const ButtonLauncher = ({
  organizationId: _organizationId,
  assistantId: _assistantId
}: ButtonLauncherProps) => {
  const handleClick = () => {
    // Notify parent SDK to show the chat iframe
    sdkBridge.sendEvent('strada:button:clicked', {});
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'fixed z-[9999] h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 hover:opacity-90 hover:scale-110',
        'right-6 bottom-6 flex items-center justify-center'
      )}
      style={{ backgroundColor: '#4127D4' }}
      aria-label="Open Strada Chat"
    >
      <MessageCircle className="h-6 w-6 text-white" />
    </button>
  );
};
